// extracted by mini-css-extract-plugin
export var activeVariantCat = "style-mod--active-variant-cat--90788";
export var badge = "style-mod--badge--d16d6";
export var multiple = "style-mod--multiple--a1e27";
export var parentVariantImg = "style-mod--parent-variant-img--b5486";
export var saleMessage = "style-mod--sale-message--0267a";
export var saleMessageParent = "style-mod--sale-message-parent--c67c1";
export var selected = "style-mod--selected--86176";
export var singleCategory = "style-mod--single-category--4108c";
export var singleCategoryNoBorders = "style-mod--single-category-no-borders--8fd85";
export var smallFonts = "style-mod--small-fonts--706e6";
export var triangle = "style-mod--triangle--eb98e";
export var variantCategoryTitle = "style-mod--variant-category-title--3d65f";
export var variantsOnSliderContainer = "style-mod--variants-on-slider-container--6e1bd";